enum DocumentType {
	PASSPORT = '21',
	NATIONAL_ID = '5'
}

const documents = [
	DocumentType.PASSPORT,
	DocumentType.NATIONAL_ID
];

const description = (ct: DocumentType) => {
	switch (ct) {
		case DocumentType.PASSPORT:
			return 'bookingDetails.label.docType.passport';
		case DocumentType.NATIONAL_ID:
			return 'bookingDetails.label.docType.nationalIdentityCard';
		default:
			return '';
	}
}

export const DocumentTypeEnum = {
	allValues: documents,
	description: description
};
